var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('div',{staticStyle:{"height":"58vh"},attrs:{"id":"placeholder"}})])}
var staticRenderFns = []

export { render, staticRenderFns }